import React, { useState, useEffect, useContext } from 'react'
import { navigate } from 'gatsby'

import imgLogoActivity from './../../../assets/images/logoActividad.png'
import imgDecoracionEstrella from './../../../assets/images/decoracionEstrella.png'
import podioPersonajes from './../../../assets/images/podioPersonajes.svg'

import userSessionStorage from '../../../utils/userSessionStorage'
import gameServices from '../../../services/game-service'

import { Context } from '../../../context/app-context'

import {
  datesActivity,
  numWinners,
  gameId,
} from '../../../constants/activity-constants'

import './topContent.scss'
import { siteUrl } from '../../../shared/utils/siteUrl'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const TopContent = props => {
  const session = new userSessionStorage()
  const { dispatch } = useContext(Context)

  const [userData, setUserData] = useState({})
  const [topWinners, setTopWinners] = useState([])

  useEffect(() => {
    getTop()
  }, [])

  const getTop = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
    gameServices.getTopPagination(gameId, numWinners, 0, config).then(res => {
      if (res.status === 200) {
        setUserData(res.data)
        setTopWinners(res.data.topGame)
      }
    })
  }

  const formatNumber = number => {
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return
  }

  const modalLogin = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: 'login',
          handleClose: () => {
            navigate('/')
          },
          props: {
            close: () => {
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
          },
        },
      },
    })
  }

  return (
    <div className="f-topContent-container">
      <div className="f-topContent-container__content">
        <div className="f-topContent-container__content__left">
          <figure className="f-participaContent-container__content__section1__logo contentLogoTopMobile">
            <h2>
              <b> TOP</b>
            </h2>
            <img
              className="f-participaContent-container__content__section1__logo__imgLogoActivity contentLogoTopMobile__imgLogoActivity"
              src={imgLogoActivity}
              alt="actividad imagen"
            />
            <img
              className="f-participaContent-container__content__section1__logo__imgDecoracionEstrella contentLogoTopMobile__imgDecoracionEstrella"
              src={imgDecoracionEstrella}
              alt="actividad imagen"
            />
          </figure>
          {!props.isMobile && (
            <img
              className="f-topContent-container__content__left__imgPodioPersonajes"
              src={podioPersonajes}
              alt="personajes de NosotrasOnline"
            />
          )}
        </div>
        <div className="f-topContent-container__content__right">
          {session.getUserInfo() ? (
            <>
              <figure className="f-topContent-container__content__right__contentPuntaje">
                <h3>¡HOLA {session.getUserInfo().name.split(' ')[0]}!</h3>
                <div className="f-topContent-container__content__right__contentPuntaje__cuadroPuntaje">
                  <p>
                    TUS PUNTOS <br />{' '}
                    <b>{userData.point ? formatNumber(userData.point) : 0}</b>
                  </p>
                  <p>
                    TU PUESTO <br /> <b>{userData.position}</b>
                  </p>
                </div>
              </figure>
              <p>
                <b>¡Busca tu nombre entre los mejores puntajes! </b>
                <br />
                <br /> Si no estás en nuestro top {numWinners}{' '}
                <b>¡sigue jugando!</b> tienes hasta el{' '}
                {datesActivity.dateEndGame} para alcanzar los mejores puntajes.
              </p>
            </>
          ) : (
            <p>
              <a onClick={() => {
                pushEventDataLayer('Personajes :: TOP', 'Click', 'Inicia sesión')
                modalLogin()
              }}>Inicia sesión</a> para conocer tu
              puntaje y tu posición dentro del <b> top de jugadoras.</b> <br />
              <br /> Si aún no formas parte de NosotrasOnline <br />
              <a
                onClick={() => {
                  pushEventDataLayer('Personajes :: TOP', 'Click', ' regístrate aquí')

                  window.open(
                    siteUrl + '/registro/fecha-de-nacimiento/',
                    '_blank'
                  )
                }}
              >
                regístrate aquí
              </a>
            </p>
          )}

          <div className="f-topContent-container__content__right__cuadroTop">
            <h3 className="f-topContent-container__content__right__cuadroTop__tituloCuadro">
              ¡Las mejores jugadoras están aquí!
            </h3>
            <div className="f-topContent-container__content__right__cuadroTop__contentList">
              <ul>
                {topWinners.map((item, index) => {
                  return (
                    <li key={'top' + index}>
                      <span>
                        <b>{index + 1}.</b> {item.name}
                      </span>
                      <span>{item.email}</span>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
          <button
            className="f-buttonYellow f-buttonYellow--sizeM"
            onClick={() => {
              pushEventDataLayer('Personajes :: TOP', 'Click', '¡QUIERO JUGAR!')
              navigate('/juegos')
            }}
          >
            QUIERO JUGAR
          </button>
        </div>
      </div>
    </div>
  )
}

export default TopContent
